import { render, staticRenderFns } from "./BloodTransfusionSignature.vue?vue&type=template&id=374ccb64&"
import script from "./BloodTransfusionSignature.vue?vue&type=script&lang=js&"
export * from "./BloodTransfusionSignature.vue?vue&type=script&lang=js&"
import style0 from "./BloodTransfusionSignature.vue?vue&type=style&index=0&id=374ccb64&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports